import { createContext } from 'react';

interface RightSideContextProps {
  setIsRightSideEmpty: (isRightSideEmpty: boolean) => void;
}

export const RightSideContext = createContext<RightSideContextProps>({} as RightSideContextProps);
